import { Modal } from "bootstrap"
import { config } from "@hotwired/turbo"

config.forms.confirm = (message, formElement) => {
  return new Promise((resolve) => {
    const modalEl = document.getElementById("turboConfirmModal")
    const modal = Modal.getOrCreateInstance(modalEl)
    const confirmButton = modalEl.querySelector("#turboConfirmButton")
    const dismissButton = modalEl.querySelector("#turboConfirmDismissButton")
    let confirmed = false

    document.getElementById("turboConfirmMessage").textContent = message
    confirmButton.textContent = formElement?.dataset.turboConfirmOk || confirmButton.dataset.defaultText
    dismissButton.textContent = formElement?.dataset.turboConfirmDismiss || dismissButton.dataset.defaultText

    const handleConfirm = () => {
      confirmed = true
      modal.hide()
    }

    const handleHidden = () => {
      confirmButton.removeEventListener("click", handleConfirm)
      resolve(confirmed)
    }

    confirmButton.addEventListener("click", handleConfirm, { once: true })
    modalEl.addEventListener("hidden.bs.modal", handleHidden, { once: true })

    modal.show()
  })
}
